import "es6-shim"
import "./lib/Number"
import axios from 'axios';
import * as Rx from 'rxjs';
import * as jsData from 'js-data';
import * as lodash from 'lodash';
import * as logger from 'loglevel';
import * as Hash from "object-hash"
import * as MathJs from "mathjs";
import {PAEnvironment} from './PA.Core/PAEnvironment'
import {MdlCore} from "./PA.Mdl.Core";

import {TagBag} from "./PA.Utils/TagBag";
import {ProductGroupBag} from "./PA.Utils/ProductGroupBag";
import {PAMetricUtils} from "./PA.Metric.Services/PAMetricUtils";
import {ConditionContext} from "./PA.Utils/ConditionContext";
import {LeaseRegistry} from "./PA.Utils/LeaseRegistry";


//UI Framework
import {MdlBO} from "./PA.Mdl.BO";
import {MdlServices} from "./PA.Mdl.Services";
import {MdlUI} from "./PA.Mdl.UI";

const Mdl = {
    Environment: PAEnvironment,

    Core: MdlCore.Core,

    BO: MdlBO.BO,

    Services: MdlServices.Services,

    UI: MdlUI.UI,

    Utils: {
        TagBag: TagBag,
        ProductGroupBag: ProductGroupBag,

        MetricUtils: PAMetricUtils,
        ConditionContext: ConditionContext,
        LeaseRegistry: LeaseRegistry
    },

    Dependents: {
        Rx: Rx,
        jsData: jsData,
        lodash: lodash,
        axios: axios,
        logger: logger,
        hash: Hash,
        MathJS: MathJs
    }

}


export {Mdl}
